<template>
  <div class="modal fade" id="modalEducacionesList" tabindex="-1" role="dialog" aria-labelledby="modalEducacionesListLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold text-primary" id="modalEducacionesListLabel">
            <i class="fas fa-book-open mr-2"></i> Histórico de Educaciones
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="cargando" class="text-center py-4">
            <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
            <p class="small text-muted mt-2">Cargando educaciones...</p>
          </div>

          <div v-else-if="educaciones.length === 0" class="alert alert-light text-center border text-muted py-3">
            No se han registrado educaciones para este usuario.
          </div>

          <div v-else class="table-responsive">
            <table class="table table-sm table-bordered table-hover mb-0">
              <thead class="bg-light small font-weight-bold">
                <tr>
                  <th style="width: 110px;">Fecha</th>
                  <th>Tema / Educación</th>
                  <th>Detalle / Texto</th>
                  <th>Profesional</th>
                  <th>Sede</th>
                  <th class="text-center" style="width: 60px;">Acciones</th>
                </tr>
              </thead>
              <tbody class="small">
                <tr v-for="item in educaciones" :key="item.id">
                  <td class="font-weight-bold">{{ formatFecha(item.fecha) }}</td>
                  <td class="font-weight-bold text-primary">
                    {{ item.educacion ? item.educacion.nombre : 'Educación' }}
                  </td>
                  <td style="white-space: pre-line;">{{ item.texto }}</td>
                  <td>{{ item.user ? item.user.name : 'N/A' }}</td>
                  <td>{{ item.sede ? item.sede.NOMBRE_SEDE :'SIN DATOS '}}</td>
                  <td class="text-center">
                    <button
                      type="button"
                      class="btn btn-xs btn-outline-info border-0 mr-1"
                      title="Imprimir Educación"
                      @click="imprimirEducacion(item.id)"
                    >
                      <i class="fas fa-print"></i>
                    </button>
                    <button
                     v-if="item.id_user===user.id"
                      type="button"
                      class="btn btn-xs btn-outline-danger border-0"
                      title="Eliminar"
                      @click="eliminarEducacion(item.id)"
                    >
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-sm" data-dismiss="modal">
            <i class="far fa-times-circle mr-1"></i> Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import historiaEducacionService from "@/services/historiaEducacionService";
import Toast from "@/components/common/utilities/toast";

export default {
  name: "ModalEducacionesList",
  props: {
    idUsuario: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      cargando: false,
      educaciones: []
    };
  },
  methods: {
    formatFecha(fecha) {
      if (!fecha) return '';
      return dayjs(fecha).format('YYYY-MM-DD');
    },
    async getEducaciones() {
      if (!this.idUsuario) return;
      this.cargando = true;
      try {
        const res = await historiaEducacionService.showByUsuario(this.idUsuario);
        this.educaciones = res.data || [];
      } catch (e) {
        console.error("Error al cargar lista de educaciones:", e);
      } finally {
        this.cargando = false;
      }
    },
    imprimirEducacion(id) {
      window.open(historiaEducacionService.print(id));
    },
    async eliminarEducacion(id) {
      try {
        const res = await historiaEducacionService.delete(id);
        if (res.data && res.data.status === "ok") {
          Toast.fire({
            icon: "success",
            title: "Educación eliminada"
          });
          await this.getEducaciones();
          this.$emit("cargar-ultima");
        }
      } catch (e) {
        console.error("Error al eliminar educación:", e);
      }
    }
  },
   computed: {
        user() {
            return this.$store.state.user;
        }
    }
};
</script>
